import { lazy } from 'react'

const OptimizeRoutes = [
  {
    path: '/home',
    component: lazy(() => import('../../views/optimize/Home')),
    meta: {
        action: 'read',
        resource: 'core'
    }
  },
  {
    path: '/data-acquire',
    component: lazy(() => import('../../views/optimize/DataAcquire')),
    meta: {
      action: 'read',
      resource: 'acquire'
    }
  },
    {
    path: '/data-regulation',
    component: lazy(() => import('../../views/optimize/DataRegulation')),
    meta: {
      action: 'read',
      resource: 'company'
    }
  },
  {
    path: '/data-company',
    component: lazy(() => import('../../views/optimize/DataCompany')),
    meta: {
      action: 'read',
      resource: 'company'
    }
  },
  {
    path: '/data-employees',
    component: lazy(() => import('../../views/optimize/DataEmployees')),
    meta: {
          action: 'read',
          resource: 'employees'
        }
  },
  {
    path: '/analytic-create',
    component: lazy(() => import('../../views/optimize/AnalyticCreate')),
    meta: {
          action: 'create',
          resource: 'analytic'
        }
  },
  {
    path: '/analytic-report',
    component: lazy(() => import('../../views/optimize/AnalyticReport')),
    meta: {
      action: 'read',
      resource: 'analytic'
    }
  },
  {
    path: '/analytic-chart',
    component: lazy(() => import('../../views/optimize/AnalyticChart')),
    meta: {
      action: 'read',
      resource: 'analytic'
    }
  },
  {
    path: '/simulation',
    component: lazy(() => import('../../views/optimize/Simulation')),
    meta: {
      action: 'create',
      resource: 'budget'
    }
  },
  {
    path: '/budget',
    component: lazy(() => import('../../views/optimize/Budget')),
    meta: {
      action: 'create',
      resource: 'budget'
    }
  },
  {
    path: '/config-client',
    component: lazy(() => import('../../views/optimize/ConfigClient')),
    meta: {
      action: 'update',
      resource: 'settings'
    }
  },
  {
    path: '/config-users',
    component: lazy(() => import('../../views/optimize/ConfigUsers')),
    meta: {
      action: 'update',
      resource: 'settings'
    }
  },
  {
    path: '/authorization-tab-content',
    component: lazy(() => import('../../views/pages/account-settings/AuthorizationTabContent'))
  },
  {
    path: '/new-user',      
    component: lazy(() => import('../../views/pages/authentication/NewUser')),
    layout: 'BlankLayout',
    meta: {
      action: 'create',
      resource: 'user'
    }
  },
  {
    path: '/ticket',      
    component: lazy(() => import('../../views/pages/authentication/Ticket')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/learn/fr',      
    component: lazy(() => import('../../views/optimize/LearnFr')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'core'
    }
  },
  {
    path: '/learn/en',      
    component: lazy(() => import('../../views/optimize/LearnEn')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'core'
    }
  },
  {
    path: '/documentation/fr',      
    component: lazy(() => import('../../views/optimize/DocumentationFr')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'core'
    }
  },
  {
    path: '/documentation/en',      
    component: lazy(() => import('../../views/optimize/DocumentationEn')),
    layout: 'BlankLayout',
    meta: {
      action: 'read',
      resource: 'core'
    }
  }
]

export default OptimizeRoutes
